import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

// Título principal de página/formulário — substitui os h4/h5/subtitle1 usados livremente por view.
export const PageTitle = ({ children, style, ...rest }) => (
  <Typography variant="h4" style={{ marginBottom: 24, ...style }} {...rest}>
    {children}
  </Typography>
);

PageTitle.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};

// Subtítulo de seção dentro de uma página/formulário — substitui os h6 usados como separador de bloco.
export const SectionTitle = ({ children, style, ...rest }) => (
  <Typography variant="h6" style={{ marginBottom: 16, ...style }} {...rest}>
    {children}
  </Typography>
);

SectionTitle.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};
